import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const userBoardViewNotFoundRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-board-view-not-found',
	path: '/jira/people/:accountId/boards/:boardId/not-found',
};
